export default __webpack_public_path__ + "static/media/5.59b0bf24.jpeg";